import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "32",
  height: "32",
  rx: "16",
  fill: "white",
  "fill-opacity": "0.1"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.7178 10.7207C11.0107 10.4277 11.4856 10.4277 11.7786 10.7207L15.9989 14.941L20.2193 10.7207C20.5122 10.4277 20.9872 10.4277 21.2801 10.7207C21.5731 11.0136 21.5731 11.4886 21.2801 11.7815L17.0598 16.0019L21.2801 20.2222C21.5731 20.5152 21.5731 20.9901 21.2801 21.283C20.9872 21.576 20.5122 21.576 20.2193 21.283L15.9989 17.0627L11.7786 21.283C11.4856 21.576 11.0107 21.576 10.7178 21.283C10.4248 20.9901 10.4248 20.5152 10.7178 20.2222L14.9381 16.0019L10.7178 11.7815C10.4248 11.4886 10.4248 11.0136 10.7178 10.7207Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }